import BaseUseCase from "../../base_use_case.js";

class ShowProjectUseCase extends BaseUseCase {

  execute(identifier, findBySlug = true) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/projects/projects/${identifier}`,
      params: {
        findBySlug: findBySlug
      },
    });
  }
}

const instance = new ShowProjectUseCase();
export default instance;